import axios from "axios";

const httpCommon = axios.create({
    baseURL: `${ process.env.VUE_APP_API_URL}`
});

export default httpCommon;